import { render } from "./CustomerTypeForm.vue?vue&type=template&id=00a75c3e"
import script from "./CustomerTypeForm.vue?vue&type=script&lang=js"
export * from "./CustomerTypeForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__